module.exports = __webpack_public_path__ + "static/img/pc_pd_1.f01665b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/pc_pd_1.png
// module id = oO5/
// module chunks = 0